import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	avatarAlt: {
		id: 'project-details.alternative-text-for-avatar-image',
		defaultMessage: 'Project avatar',
		description: '',
	},
});
